// extracted by mini-css-extract-plugin
export default {"list":"InputSuggestionList_list__WOzqp","item":"InputSuggestionList_item__+MpxG"};